import {PromiseType} from 'utility-types'

import {Action} from '../reactive/action'
import {baseRequest} from '../request'
import {API_URL} from '../../lib'

// without this a hung connection holds the refresh open indefinitely and the retry
// schedule never gets to run. 10s also bounds how often 401-triggered joins can force attempts.
export const REFRESH_REQUEST_TIMEOUT_MS = 10000

export class RefreshTokenAction extends Action<void, PromiseType<ReturnType<typeof baseRequest>>> {
  static readonly instance = Object.freeze(new RefreshTokenAction())

  private constructor() {
    super(() =>
      baseRequest({
        method: 'post',
        url: `${API_URL}/v1/web/identity-refresh-token-submit`,
        data: {},
        timeout: REFRESH_REQUEST_TIMEOUT_MS,
      }),
    )
  }
}
